"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _arrow_up = _interopRequireDefault(require("../../assets/images/arrow_up.svg"));
var _arrow_down = _interopRequireDefault(require("../../assets/images/arrow_down.svg"));
var _uiOptimisationAccordionDownArrow = _interopRequireDefault(require("../../assets/images/ui-optimisation-accordion-down-arrow.svg"));
var _uiOptimisationAccordionUpArrow = _interopRequireDefault(require("../../assets/images/ui-optimisation-accordion-up-arrow.svg"));
var _context = require("../ConfigProvider/context");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _RichText = require("../RichText");
var _useTracking2 = require("../../hooks/useTracking");
var _constants = require("../../utils/tracking/constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

// const CLOSE_ALL_INDEX = -1;
var AccordionItem = function AccordionItem(props) {
  var title = props.title,
    content = props.content,
    expand = props.expand,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    hasLine = props.hasLine,
    _props$defaultSelecte = props.defaultSelected,
    defaultSelected = _props$defaultSelecte === void 0 ? false : _props$defaultSelecte,
    isLastIndex = props.isLastIndex; // const [stateSelected, setStateSelected] = useState<boolean>(defaultSelected);
  // const selected = isUIOptimisationAccordion ? propsSelected : stateSelected;

  var _useState = (0, _react.useState)(defaultSelected),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1]; // 根据 是否是 ui 优化 而选用不同的 箭头 icon

  var arrowIcon = isUIOptimisationAccordion ? selected ? _uiOptimisationAccordionUpArrow.default : _uiOptimisationAccordionDownArrow.default : selected ? _arrow_up.default : _arrow_down.default; // 就算 expand 为 false 但是 在 ui 优化时也需要箭头

  var Icon = expand || isUIOptimisationAccordion ? arrowIcon : null;
  var _useTracking = (0, _useTracking2.useTracking)(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var onClose = function onClose() {
    var _context$eventEmitter, _context$eventEmitter2;
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, 'closeGlobalModal');
  };
  var articleContentTrackingData = _objectSpread(_objectSpread({}, props.articleContentTrackingData), {}, {
    trackingsection: _constants.TRACKING_SECTION.AccordionDetail
  });
  var onClick = function onClick() {
    if (!expand) {
      return;
    }
    trackingClick && tracker.click(trackingClick); // if (isUIOptimisationAccordion) {
    //   handleSetOpenItemIndex(selected ? CLOSE_ALL_INDEX : index);
    // } else {
    //   setStateSelected(!selected);
    // }

    setSelected(!selected);
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _getPrefixCls.getPrefixCls)('accordion-item')
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('title', 'accordion-left-title', {
      selected: selected
    }, {
      'ui-optimisation-accordion-title': isUIOptimisationAccordion
    }),
    onClick: onClick
  }, isUIOptimisationAccordion ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)('ui-optimisation-accordion-title-text')
  }, title) : title, Icon && /*#__PURE__*/_react.default.createElement("img", {
    src: Icon,
    className: (0, _getPrefixCls.getPrefixCls)('accordion-item-icon')
  })), selected && /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    className: (0, _clsx.default)('accordion-item-content', {
      'last-selected': selected && isLastIndex
    }),
    content: content,
    articleContentTrackingData: articleContentTrackingData,
    onClose: onClose
  }), hasLine && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('accordion-item-line-container')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('accordion-item-line'),
    style: selected ? {
      height: 2
    } : {}
  })));
};
var Accordion = function Accordion(props) {
  var accordionList = props.accordionList,
    _props$expand = props.expand,
    expand = _props$expand === void 0 ? true : _props$expand,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    defaultSelectIndex = props.defaultSelectIndex; // const [openItemIndex, setOpenItemIndex] = useState(Number(defaultSelectIndex) ?? CLOSE_ALL_INDEX);
  // const handleSetOpenItemIndex = (index: number) => {
  //   setOpenItemIndex(index);
  // };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('accordion-container'), isUIOptimisationAccordion && (0, _getPrefixCls.getPrefixCls)('accordion-container-ui-optimisation-accordion'))
  }, accordionList.map(function (item, index) {
    var _props$trackingData;
    var trackingData = props.trackingData ? _objectSpread(_objectSpread({}, props.trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, ((_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : _props$trackingData.trackingdataBasic) || {}), {}, {
        content: item.title,
        location: index
      })
    }) : undefined;
    return /*#__PURE__*/_react.default.createElement(AccordionItem, {
      key: item.content + item.title + index,
      title: item.title,
      content: item.content,
      trackingData: trackingData,
      articleContentTrackingData: trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic,
      expand: expand,
      isUIOptimisationAccordion: isUIOptimisationAccordion // selected={index === openItemIndex}
      ,

      index: index,
      isLastIndex: index === accordionList.length - 1,
      defaultSelected: defaultSelectIndex === index // handleSetOpenItemIndex={handleSetOpenItemIndex}
      ,

      hasLine: index !== accordionList.length - 1 && isUIOptimisationAccordion
    });
  }));
};
exports.Accordion = Accordion;